module.exports = __webpack_public_path__ + "static/media/worker_idle_sel.77d3fa8e.svg";